import React, { useCallback } from 'react';
import { Button, Popconfirm } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import { TreeNode } from '../../types/types';
import { useAuth } from '../../auth/authcontext';

interface UseTreeTitleRendererProps {
    isEditable: boolean;
    data: TreeNode[];
    handleRemoveNode: (key: string, title: string) => void;
}

export const useTreeTitleRenderer = ({
    isEditable,
    data,
    handleRemoveNode,
}: UseTreeTitleRendererProps): ((nodeData: TreeNode) => React.ReactElement) => {
    const { isReadOnly } = useAuth();
    
    const renderTreeTitle = useCallback(
        (nodeData: TreeNode): React.ReactElement => {
            const isRootNode = data[0] && nodeData.key === data[0].key;

            const handleConfirmDelete = (e?: React.MouseEvent<HTMLElement>) => {
                e?.stopPropagation();
                handleRemoveNode(nodeData.key, nodeData.title);
            };

            const handleCancelDelete = (e?: React.MouseEvent<HTMLElement>) => {
                e?.stopPropagation();
            };

            return (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '100%',
                    }}
                    onClick={() => { }}
                >
                    <span>{nodeData.title}</span>
                    {isEditable && !isRootNode && !isReadOnly && (
                        <Popconfirm
                            title={
                                <>
                                    Delete "<strong>{nodeData.title}</strong>" and all its children?
                                </>
                            }
                            description="This action cannot be undone."
                            onConfirm={handleConfirmDelete}
                            onCancel={handleCancelDelete}
                            okText="Yes, Delete"
                            cancelText="No"
                            placement="right"
                        >
                            <Button
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={(e) => e.stopPropagation()}
                                size="small"
                                style={{ marginLeft: 8, lineHeight: 1, padding: '4px' }}
                            />
                        </Popconfirm>
                    )}
                </div>
            );
        },
        [isEditable, data, handleRemoveNode, isReadOnly]
    );

    return renderTreeTitle;
};